<app-form-wrapper title="Recipients">
  <form (submit)="$event.preventDefault()">
    <div class="cf__body">
      <p class="cf__lead">
        Choose organizations, tags or segments, in any mix. Someone who belongs to more than one group is
        counted once.
      </p>

      <!-- Organizations -->
      <div>
        <input-field label="Organizations">
          <button type="button" class="cf__picker" aria-haspopup="dialog" (click)="openOrgModal = true">
            <span class="cf__picker-value" [class.is-empty]="!selectedOrganizations.length">
              {{ summary(selectedOrganizations.length, "organization", "organizations") }}
            </span>
            <span class="bk-sym" aria-hidden="true">expand_more</span>
          </button>
        </input-field>
        @if (selectedOrganizations.length) {
          <ul class="cf__chosen" aria-label="Chosen organizations">
            @for (item of selectedOrganizations; track $index) {
              <li class="cf__chip">
                <span class="cf__chip-name">{{ item.name }}</span>
                <button
                  type="button"
                  class="bk-icon-btn"
                  [attr.aria-label]="'Remove ' + item.name"
                  (click)="removeOrganization(item)"
                >
                  <span class="bk-sym" aria-hidden="true">close</span>
                </button>
              </li>
            }
          </ul>
        }
      </div>

      <div class="cf__row">
        <!-- Tags -->
        <div>
          <input-field label="Tags">
            <button type="button" class="cf__picker" aria-haspopup="dialog" (click)="openTagModal = true">
              <span class="cf__picker-value" [class.is-empty]="!selectedTags.length">
                {{ summary(selectedTags.length, "tag", "tags") }}
              </span>
              <span class="bk-sym" aria-hidden="true">expand_more</span>
            </button>
          </input-field>
          @if (selectedTags.length) {
            <ul class="cf__chosen" aria-label="Chosen tags">
              @for (item of selectedTags; track $index) {
                <li class="cf__chip">
                  <span class="cf__chip-name">{{ item.name }}</span>
                  <button
                    type="button"
                    class="bk-icon-btn"
                    [attr.aria-label]="'Remove ' + item.name"
                    (click)="removeTag(item)"
                  >
                    <span class="bk-sym" aria-hidden="true">close</span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>

        <!-- Segments -->
        <div>
          <input-field label="Segments">
            <button type="button" class="cf__picker" aria-haspopup="dialog" (click)="openSegModal = true">
              <span class="cf__picker-value" [class.is-empty]="!selectedSegments.length">
                {{ summary(selectedSegments.length, "segment", "segments") }}
              </span>
              <span class="bk-sym" aria-hidden="true">expand_more</span>
            </button>
          </input-field>
          @if (selectedSegments.length) {
            <ul class="cf__chosen" aria-label="Chosen segments">
              @for (item of selectedSegments; track $index) {
                <li class="cf__chip">
                  <span class="cf__chip-name">{{ item.name }}</span>
                  <button
                    type="button"
                    class="bk-icon-btn"
                    [attr.aria-label]="'Remove ' + item.name"
                    (click)="removeSegment(item)"
                  >
                    <span class="bk-sym" aria-hidden="true">close</span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="cf__foot">
      <button type="button" class="bk-btn bk-btn--ghost" (click)="this.cancelCampaignService.openCancelModal()">
        Cancel
      </button>
      <div class="cf__foot-end">
        @if (invalid) {
          <p class="cf__foot-note">Choose at least one group to continue.</p>
        } @else if (audience.loading) {
          <p class="cf__foot-note">Counting recipients…</p>
        } @else if (audience.count !== null) {
          <p class="cf__foot-note">
            Reaches <strong>{{ formatCount(audience.count) }}</strong>
            {{ audience.count === 1 ? "person" : "people" }}
          </p>
        }
        <button type="button" class="bk-btn bk-btn--ghost" (click)="goBack()">Back</button>
        <button type="button" class="bk-btn bk-btn--primary" [disabled]="invalid" (click)="handleSubmit()">
          Continue to messages
          <span class="bk-sym cf__go" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    </div>
  </form>
</app-form-wrapper>

<!-- pickers -->
@if (openOrgModal) {
  <add-organizations-modal
    [open]="openOrgModal"
    (close)="openOrgModal = false"
    [selection]="selectedOrganizations"
    (updateSelection)="getSelectedOrganizations($event)"
  ></add-organizations-modal>
}
@if (openTagModal) {
  <add-tags-modal
    [open]="openTagModal"
    (close)="openTagModal = false"
    [selection]="selectedTags"
    (updateSelection)="getSelectedTags($event)"
  ></add-tags-modal>
}
@if (openSegModal) {
  <add-segments-modal
    [open]="openSegModal"
    (close)="openSegModal = false"
    [selection]="selectedSegments"
    (updateSelection)="getSelectedSegments($event)"
  ></add-segments-modal>
}
